<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-02-07 22:56:02
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-03-12 20:11:32
-->
<template>
  <div class="container">
    <!-- <div class="container-header">
      <page-title text="基本信息"></page-title>
    </div> -->
    <div class="container-content">
      <el-descriptions direction="vertical" :column="2" border v-if="user">
        <el-descriptions-item label="用户名">{{
          user.userName
        }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{
          user.phoneNum ? user.phoneNum : "暂无数据"
        }}</el-descriptions-item>
        <el-descriptions-item label="企业">{{
          user.enterpriseName
        }}</el-descriptions-item>
        <el-descriptions-item label="邮箱地址">{{
          user.email
        }}</el-descriptions-item>
      </el-descriptions>
      <el-empty :description="errMsg" v-else></el-empty>
    </div>
  </div>
</template>

<script>
import HTTP_USER from "@/api/user";
export default {
  name: "BasicInfo",
  data() {
    return {
      roleSet: [],
      user: null,
      errMsg: "数据获取失败，请联系管理员",
    };
  },
  mounted() {
    this.getBasicInfo();
  },
  methods: {
    async getBasicInfo() {
      const res = await HTTP_USER.getUserInfo();
      if (res.code === 200) {
        this.user = res.data.user;
        this.roleSet = res.data.roleSet;
      } else {
        this.errMsg = res.msg;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 12px;
}
</style>
